import {formatDate} from '@pb/kit-formatters';


export const dateToDateString = (date: Date) => {
    return formatDate(date.toISOString(), 'YYYY-MM-DD');
};
